module.exports = __webpack_public_path__ + "static/media/address-f-red-icon.5f15c52e.svg";